import {FieldError} from './phase-validation-result.model';
import {OptionalValidationForm} from './step-forms/optional-validation-form.model';

export enum CreditBureauProviderType {
  CIBI = 'CIBI'
}

export enum CreditBureauStatusType {
  MATCH = 'MATCH',
  NO_MATCH = 'NO_MATCH',
  NO_SCORE = 'NO_SCORE',
  ERROR = 'ERROR'
}

export interface CreditScore {
  id: number;
  status: CreditBureauStatusType;
  score: string;
  riskGrade: string;
  reportPdf: string;
  errors: FieldError[];
}

export interface CreditBureauSearchCriteria {
  applicationId: string;
  provider: CreditBureauProviderType;
  includeCreditReport?: boolean;
}

export interface CreditCheckFormFields extends OptionalValidationForm {
  applicationId: string;
}